module.exports = __webpack_public_path__ + "img/circle-dollar-to-slot.dff86a3f.svg";